import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navigation from './components/Navigation';
import SplashScreen from './components/SplashScreen';
import Login from './pages/Login';
import Profile from './pages/Profile';
import Memories from './pages/Memories';
import Chat from './pages/Chat';
import Calendar from './pages/Calendar';
import Settings from './pages/Settings';
import UserProfile from './pages/UserProfile';
import Users from './pages/Users';
import { Fade } from '@mui/material';
import './styles/main.css';
import { injectSpeedInsights } from "@vercel/speed-insights";

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    // Add a slight delay to start the fade-in effect for the main app
    const timer = setTimeout(() => {
      setFadeIn(true);
    }, 2800); // Start fade-in slightly before splash screen ends
    
    return () => clearTimeout(timer);
  }, []);

  const handleSplashFinished = () => {
    setShowSplash(false);
  };

  return (
    <>
      {showSplash && <SplashScreen onFinished={handleSplashFinished} />}
      <Fade in={!showSplash || fadeIn} timeout={600}>
        <div style={{ visibility: showSplash && !fadeIn ? 'hidden' : 'visible' }}>
          <Router>
            <AuthProvider>
              <NotificationProvider>
                <div className="app">
                  <Navigation />
                  <main className="main-content">
                    <Routes>
                      <Route path="/login" element={<Login />} />
                      <Route path="/" element={<ProtectedRoute><Memories /></ProtectedRoute>} />
                      <Route path="/memories" element={<ProtectedRoute><Memories /></ProtectedRoute>} />
                      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                      <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
                      <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
                      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                      <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
                      <Route path="/user/:userId" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
                    </Routes>
                  </main>
                </div>
              </NotificationProvider>
            </AuthProvider>
          </Router>
        </div>
      </Fade>
    </>
  );
}

// Initialize Speed Insights
injectSpeedInsights();

export default App; 